import "./WaveLoader.css";
export const WaveLoader = () => {
  return (
    <div className="wave-loader">
      <span className="wave-dot"></span>
      <span className="wave-dot"></span>
      <span className="wave-dot"></span>
    </div>
  );
};
